import { ApiQueryPromise, MarketLabel } from '@/types';
import { getResponseJwtHeader } from '@/utils/web';
import { fetchComposer } from '@nf/utils-common/compose-fetch';
import { useSiteStore } from '@/store/site';
import { cloudUrlParser } from '@/utils/aws-domain-util';

export interface OpenAdvantPlayProps {
	betType?: string;
	isApp?: boolean;
}

export const getAdvantPlayUrl = async (props: OpenAdvantPlayProps, token?: string): Promise<string> => {
	const { ctcdDomain } = useSiteStore.getState().apiDomain;
	const gmt = new Date().getTimezoneOffset() / -60;

	const params: Record<string, string> = {
		SportID: '172',
		BetType: props.betType ?? '0',
		GMT: String(gmt),
		host: window.location.host,
	};

	const queryString = new URLSearchParams(params).toString();
	const response = await fetchComposer.getWithBearer(
		cloudUrlParser(`${ctcdDomain}/AuthorizationCustomer/Authorization3rdGame?${queryString}`)
	)(token);

	if (!response.ok) {
		throw new Error(`${response.status}: ${response.statusText}`);
	}

	const text = await response.text();
	try {
		const json = JSON.parse(text) as { Data?: string | null; ErrorCode?: number; ErrorMsg?: string };
		if (json.ErrorCode !== undefined && json.ErrorCode !== 0) {
			throw new Error(json.ErrorMsg ?? `ErrorCode: ${json.ErrorCode}`);
		}
		if (!json.Data) {
			throw new Error('Authorization3rdGame returned empty URL');
		}
		return json.Data;
	} catch (e) {
		if (!(e instanceof SyntaxError)) throw e;
		const url = text.trim() || response.url;
		if (!url) throw new Error('Authorization3rdGame returned empty URL');
		return url;
	}
};

interface OpenESportProps {
	siteId?: string;
	umSource?: string;
	gameId?: string;
	market?: MarketLabel | null;
	leagueId?: number;
	matchId?: number;
	isDeepLink?: boolean;
	isApp?: boolean;
}
export const getESportWebUrl = async (openESportProps: OpenESportProps, token?: string): Promise<ApiQueryPromise<string>> => {
	const { ctcdDomain } = useSiteStore.getState().apiDomain;
	const filteredParams = Object.keys(openESportProps).reduce((acc, key) => {
		const value = openESportProps[key as keyof OpenESportProps];
		if (key == 'isApp' && openESportProps['isApp']) {
			acc['host'] = window.location.host;
		} else if (value !== undefined && value !== null) {
			acc[key] = value;
		}
		return acc;
	}, {} as Record<string, any>);
	
	const queryString = Object.keys(filteredParams)
		.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(filteredParams[key]))
		.join('&');

	const response = await fetchComposer.getWithBearer(
		cloudUrlParser(`${ctcdDomain}/AuthorizationCustomer/OpenEsportWeb?${queryString}`)
	)(token);

	if (!response.ok) {
		throw new Error(`${response.status}: ${response.statusText}`);
	}

	return {
		data: await response.json(),
		jwtToken: getResponseJwtHeader(response)
	};
};